import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { listAllHireEmployer } from "../../actions/employerAction";
import AdminMenu from "../../components/AdminMenu";
import RightDash from "../../components/RightDash";
import Message from "../../components/Message";
import "../../styles/dashboard.css";
import Signout from "../../components/Signout";

const AdminJobs = ({ resizeMenu, setResizeMenu }) => {
  const dispatch = useDispatch();

  const listAllHire = useSelector((state) => state.listAllHire);

  const { hire, hireloading, error } = listAllHire;

  useEffect(() => {
    dispatch(listAllHireEmployer());
  }, [listAllHireEmployer]);

  return (
    <div className="dashboard">
      <AdminMenu resizeMenu={resizeMenu} setResizeMenu={setResizeMenu} />
      <RightDash resizeMenu={resizeMenu} setResizeMenu={setResizeMenu}>
        {hireloading ? (
          <div className="d-flex justify-content-center align-items-center w-100 h-100">
            <div className="spinner-blue"></div>
          </div>
        ) : error ? (
          <Message variant="danger">{error}</Message>
        ) : (
          <div className="right-wrapper">
            <div className="bio text-right">
              <button>
                <span>Hello Admin, Welcome!</span>
                <span className="px-50 py-25 rounded-circle ml-25 font-weight-bold font-sm">
                  A
                </span>
              </button>
            </div>
            <div className="main p-3">
              <div className="my-2 mx-25">
                <h4 className="font-normal mb-25">Hire requests</h4>
                <div className="overflow-x">
                  <div>
                    {hire.length === 0 && <div>No hire request posted yet</div>}
                    {hire.map((hire) => (
                      <div
                        key={hire._id}
                        className="d-flex justify-content-between align-items-center table shadow-sm border mb-1 px-1 py-50">
                        <div>
                          <div className="date">
                            {hire.createdAt.slice(0, 10)}
                          </div>
                          <div className="nameemail">
                            by {hire.user.name} -{" "}
                            <a href={`mailto:${hire.user.email}`}>
                              {hire.user.email}
                            </a>
                          </div>
                          <div className="company">
                            {hire.company} - {hire.country}
                          </div>
                          <div className="requestmade font-weight-bolder">
                            Employee request -{" "}
                            <span className="font-weight-bolder">
                              {hire.employeesnumber}
                            </span>
                          </div>
                        </div>
                        <div>
                          <div className="budget font-weight-bolder text-right">
                            skills
                          </div>
                          <div className="status text-right font-sm">
                            {hire.skillrequest.join(", ")}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </RightDash>
    </div>
  );
};

export default AdminJobs;
